import { Component, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { AuthStore } from './core/store/auth.store';
import { SessionTimeoutService } from './core/services/session-timeout.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private router = inject(Router);
  private auth = inject(AuthStore);
  private sessionTimeout = inject(SessionTimeoutService);

  showHeader = toSignal(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        if (url.startsWith('/login') || url.startsWith('/change-password')) {
          return false;
        }
        return this.auth.isAuthenticated();
      })
    ),
    { initialValue: false }
  );

  constructor() {
    // Start/stop session timeout based on auth state
    effect(() => {
      if (this.auth.isAuthenticated()) {
        this.sessionTimeout.start();
      } else {
        this.sessionTimeout.stop();
      }
    });
  }
}
